/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scope_TeamInputs */

const cs_scope_team = /** @type {(inputs: Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tým`)
};

const en_scope_team = /** @type {(inputs: Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Scope_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const scope_team = /** @type {((inputs?: Scope_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scope_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scope_team(inputs)
	return cs_scope_team(inputs)
});